import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { currency } from "../shared";

/**********************
 * Order confirmation & others (unchanged)
 *********************/
function OrderConfirmation() {
  const { state } = useLocation();
  const { id } = useParams();
  const order =
    state?.order ||
    (typeof window !== "undefined"
      ? JSON.parse(sessionStorage.getItem(`order:${id}`) || "null")
      : null);
  if (!order) {
    return (
      <section className="jh-container jh-section">
        <h1 className="jh-title">Order not found</h1>
        <p className="jh-sub">
          If you placed an order recently, try refreshing or return to{" "}
          <Link to="/">home</Link>.
        </p>
      </section>
    );
  }
  const payMsg =
    order.payment?.method === "paypal"
      ? `Paid with PayPal${
          order.payment?.payerEmail ? ` (${order.payment.payerEmail})` : ""
        }.`
      : order.payment?.method === "card"
        ? `Paid with card ending in ${order.payment?.last4 || ""}.`
        : order.payment?.method === "apple"
          ? `Paid with Apple Pay.`
          : "Payment complete.";
  return (
    <section className="jh-container jh-section">
      <h1 className="jh-title">Thank you! Your order is confirmed.</h1>
      <p className="jh-sub">
        Order <strong>{order.id}</strong> • Placed{" "}
        {new Date(order.at).toLocaleString()}
      </p>
      <div className="jh-note" style={{ marginTop: 10 }}>
        Handmade to order — please allow 2–3 weeks.
      </div>
      <div className="jh-card jh-pane" style={{ marginTop: 12, padding: 16 }}>
        <h2 className="jh-pane-title">Summary</h2>
        <ul className="jh-mini-list">
          {order.items.map((it, idx) => (
            <li key={idx} className="jh-mini-row">
              <span>
                {it.name}
                {it.metal ? ` (${it.metal}` : ""}
                {it.size != null
                  ? `${it.metal ? ", " : " ("}Size ${it.size})`
                  : it.metal
                    ? ")"
                    : ""}{" "}
                × {it.qty}
              </span>
              <strong>{currency(it.unitPrice * it.qty)}</strong>
            </li>
          ))}
        </ul>
        <div className="jh-cart-row">
          <span>Subtotal</span>
          <strong>{currency(order.pricing.subtotal)}</strong>
        </div>
        {order.pricing.discount > 0 && (
          <div className="jh-cart-row">
            <span>Discount</span>
            <strong>-{currency(order.pricing.discount)}</strong>
          </div>
        )}
        <div className="jh-cart-row">
          <span>Tax</span>
          <strong>{currency(order.pricing.tax)}</strong>
        </div>
        <div className="jh-cart-row">
          <span>Shipping</span>
          <strong>{currency(order.pricing.shipping)}</strong>
        </div>
        <div className="jh-cart-row total">
          <span>Total</span>
          <strong>{currency(order.pricing.total)}</strong>
        </div>
      </div>
      <div className="jh-note" style={{ marginTop: 12 }}>
        {payMsg} A receipt was sent to {order.shipping.email}.
      </div>
      <div className="jh-actions" style={{ marginTop: 16 }}>
        <Link to="/" className="jh-btn">
          Continue shopping
        </Link>
      </div>
    </section>
  );
}

export default OrderConfirmation;
